import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

function mount() {
  const el = document.getElementById("root")!;
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

// Wait for Office to be ready when running inside Word; still mount in a plain browser (dev).
if (typeof Office !== "undefined" && Office.onReady) {
  Office.onReady(() => mount());
} else {
  mount();
}
